import i18next from "i18next";
import {initReactI18next} from "react-i18next";
import {getDefaultLang} from "../utils/utils";
import en from "./en";
import cn from "./cn";
import hk from "./hk";
import ar from "./ar";
import tr from "./tr";
import kr from "./kr";
import ja from "./ja";
import pt from "./pt";
import es from "./es";
import th from "./th";
import fr from "./fr";
// import ru from "./ru";

const resources = {
  cn: cn,
  hk: hk,
  en: en,
  ar: ar,
  tr: tr,
  kr: kr,
  ja: ja,
  pt: pt,
  es: es,
  th: th,
  fr: fr,
  // ru: ru
};

const defaultLang = getDefaultLang();

i18next.use(initReactI18next).init({
  resources,
  lng: defaultLang,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false
  }
});
